import { render, staticRenderFns } from "./StorageLocation.vue?vue&type=template&id=fc08e736"
import script from "./StorageLocation.vue?vue&type=script&lang=js"
export * from "./StorageLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports